<template>
  <div class="brick_box">
    <table class="write_tbl">
      <tbody>
        <tr>
          <th style="padding-left: 30px">{{ $t("common.title") }}</th>
          <td>
            <input
              type="text"
              id="title"
              name="title"
              v-validate="'required'"
              v-model="qna.title"
              class="form-control text"
            />
          </td>
        </tr>
        <tr>
          <th style="padding-left: 30px">{{ $t("common.file") }}</th>
          <td>
            <uploader
              :options="options"
              class="uploader-example"
              :autoStart="false"
              :size="10"
              @file-added="filesAdded"
              @file-removed="fileRemoved"
            >
              <uploader-unsupport></uploader-unsupport>
              <uploader-drop>
                <uploader-btn>Select or drag&drop file</uploader-btn>
              </uploader-drop>
              <uploader-list></uploader-list>
            </uploader>
            <div class="view_file" v-if="files.length > 0 && files != null">
              <ul>
                <li>
                  <a v-for="(file, index) in files" :key="index" href="#">
                    {{ file.fileNm }}
                    <button @click="deleteFile(file)" class="del_bt">Del</button>
                  </a>
                </li>
              </ul>
            </div>
          </td>
        </tr>
        <tr>
          <th style="padding-left: 30px">{{ $t("common.classify") }}</th>
          <td>
            <select
              id="searchClass"
              v-model="qna.classId"
              class="m-1 form-control"
              v-validate="'required'"
            >
              <option value="">--{{ $t("support.qna.selectClassification") }}--</option>
              <option
                v-for="(clazz, index) in classList"
                :key="index"
                :value="clazz.classId"
              >
                {{ clazz.className }}
              </option>
            </select>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <ckeditor
              v-validate="'required'"
              class="textarea_type"
              v-model="qna.content"
              name="content"
              :config="editorConfig"
            ></ckeditor>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="list_bottom_bt">
      <router-link to="/mylibrary/myqna" class="btn btn-outline-dark btn-lg m-1">{{
        $t("common.list")
      }}</router-link>
      <button type="button" @click="saveQna" class="btn btn-primary btn-lg">
        {{ $t("common.save") }}
      </button>
    </div>
    <div class="botm_center_wrap">
      <span class="botm_center">
        <a
          target="_blank"
          href="http://www.samsung.com/global/business/telecommunication-systems/info/contactus.html"
          class="link_center"
          title="Go Tech.Center"
        >
        </a>
      </span>
    </div>
  </div>
</template>

<script>
import { getQna, insertQna, getUserQnaClsList } from "@/api/qna";
import { deleteFile } from "@/api/file";

export default {
  data() {
    return {
      qna: { qnaFiles: [], flag: "I" },
      editorConfig: {
        filebrowserImageUploadUrl: "/img/fileupload",
        filebrowserUploadMethod: "form",
      },
      files: [],
      classList: [],
      options: {
        testChunks: false,
        chunkSize: "10", //Block size
        maxChunkRetries: 3,
      },
      boardId: "",
      newFiles: [],
      refuseFileType: [
        "asp",
        "aspx",
        "jsp",
        "php",
        "inc",
        "cgi",
        "html",
        "htm",
        "js",
        "jar",
        "jhtml",
        "php3",
        "phtml",
      ],
    };
  },
  mounted() {
    this.getQnaCls();
    if (this.$route.params.boardId != null) {
      this.fetchData();
    }
  },
  methods: {
    async getQnaCls() {
      try {
        const { data } = await getUserQnaClsList();
        this.classList = data.qaClsList;
      } catch (err) {
        console.log(err);
      }
    },
    filesAdded(file) {
      let tmp = file.file.name;
      let fileName = tmp.split(".");
      // 파일 확장자 확인
      for (let i in this.refuseFileType) {
        if (fileName[fileName.length - 1] == this.refuseFileType[i]) {
          alert(this.$t("alert.ThisIsNotAnAllowedFile"));
          file.ignored = true;
          return;
        }
      }
      this.newFiles.push(file.file);
    },
    fileRemoved(file) {
      if (this.newFiles.length > 0) {
        for (let i = 0; i < this.newFiles.length; i++) {
          if (this.newFiles[i].name == file.file.name) {
            this.$delete(this.newFiles, i);
          }
        }
      }
    },
    async fetchData() {
      try {
        this.boardId = this.$route.params.boardId;
        const response = await getQna(this.boardId);
        this.qna = response.data.qna;
        this.qna.flag = "U";
        this.files = response.data.files;
      } catch (err) {
        console.log(err);
      }
    },
    async saveQna(e) {
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      try {
        // 파일 formData 추가
        const formData = new FormData();
        formData.append("title", this.qna.title);
        formData.append("classId", this.qna.classId);
        formData.append("content", this.qna.content);
        formData.append("flag", this.qna.flag);
        formData.append("boardId", this.boardId);
        if (this.newFiles != null && this.newFiles != "") {
          for (var i = 0; i < this.newFiles.length; i++) {
            let file = this.newFiles[i];
            formData.append("qnaFiles", file);
          }
        }
        const { data } = await insertQna(formData);
        if (data.fileMessage != null && data.message != null) {
          alert(this.$t("alert.ThisIsNotAnAllowedFile"));
        } else if (data.fileMessage == null && data.message != null) {
          alert(this.$t("alert.plzCheckAllValues"));
        }
        if (data.status) {
          this.$router.push({ name: "myqnaList" });
        }
      } catch (err) {
        console.log(err);
      }
      e.preventDefault();
    },
    async deleteFile(file) {
      if (!confirm(this.$t("alert.delete"))) return;
      try {
        const { data } = await deleteFile(file);
        if (data.status) {
          this.qna = "";
          this.files = [];
          alert(this.$t("alert.deletedSuccessfully"));
          this.fetchData();
        } else {
          alert(this.$t("alert.ErrorPleasecontactManager"));
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style></style>
